var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevisionInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57409_6962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9374 13.2959C25.128 13.7515 27.5755 15.9397 27.5755 18.3907V18.4433C27.5755 21.1556 24.5781 23.4246 20.8939 23.5016L19.6957 23.5267V25.4603L16.0054 21.8572L19.6957 18.2539V20.2941L21.0289 20.1757C24.0712 19.9053 26.3658 17.9296 26.3658 15.58C26.3658 15.5794 26.3658 15.5786 26.3658 15.578",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9355 16.6475C23.266 16.905 24.4108 17.4972 25.2188 18.2955",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06406 12.6469C2.87352 12.1915 0.425293 10.0033 0.425293 7.55215V7.4995C0.425293 4.78728 3.42288 2.51805 7.10755 2.44123L8.30579 2.4161V0.482422L11.9961 4.08567L8.30579 7.68894V5.64875L6.97259 5.76722C3.93027 6.03754 1.63596 8.01322 1.63596 10.3629C1.63596 10.3635 1.63596 10.3643 1.63596 10.3649",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06564 9.29549C4.73464 9.03798 3.59031 8.44562 2.78223 7.64746",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 8.86523H19.1376",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5609 22.313H7.46601C6.76263 22.313 6.19287 21.7475 6.19287 21.0498V7.44922",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4971 3.50098H20.4532C21.156 3.50098 21.7262 4.0665 21.7262 4.76416V18.5488",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 10.502H19.1376",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 12.1377H19.1376",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 13.7734H19.1376",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 15.4092H19.1376",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78174 17.0449H14.1915",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57409_6962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionInfo);
export default __webpack_public_path__ + "static/media/revision_info.c2cfc752eecf24bb089c215fbc2ac5c0.svg";
export { ForwardRef as ReactComponent };